import { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import axios from "../config/axios";
import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import DetailsComponent from "../components/careersPartials/DetailsComponent";
import { useGeneral } from "../components/contexts/GeneralContext";
import FullScreenLoading from "../components/common/loading/FullScreenLoading";
import ApiErrorMessage from "../components/common/ApiErrorMessage";
import NoItemsFound from "../components/common/NoItemsFound";
const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};
const CareersDetailsPage = () => {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { discountCoupons } = useGeneral();
  useScrollToTop();
  useEffect(() => {
    let active = true;
    setLoading(true);

    axios
      .get(`/jobs/${id}`)
      .then(({ data }) => {
        if (active) setJob(data?.item);
      })
      .catch((err) => {
        console.error(err);
        if (active)
          setError("Failed to load job details. Please try again later.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [id]);

  const jobContent = useMemo(
    () => job && <DetailsComponent job={job} />,
    [job]
  );

  return (
    <PageWrapper loading={loading}>
      <Header code={discountCoupons} />
       {loading && <FullScreenLoading />}
      <BodyWrapper loading={loading} className="">
       
        {error ? (
          <ApiErrorMessage
            message1="Failed to load job details"
            message2="Please check your connection or try again."
          />
        ) : job ? (
          <div className="grid grid-cols-1">{jobContent}</div>
        ) : (
          <NoItemsFound
            message1="No job details available"
            message2="Please try again later."
          />
        )}
      </BodyWrapper>
      <Footer />
    </PageWrapper>
  );
};

export default CareersDetailsPage;
